import { AxiosResponse } from 'axios';
import { Event } from '../model/event';
import { EventCompleteResponse } from '../model/event-complete-response';
import { EventDay } from '../model/event-day';
import { Status } from '../model/status';
import { get, patch, _delete } from './apiUtil';
import { EventCompleteRequest } from '../model/event-complete-request';
import { EventCompletionMode } from '../model/eventCompletionMode';
import { FailedEventDay } from '../model/failed-event-day';
import CameraDeleteRequest from '../model/camera-delete-request';

export function getEvent(eventId: string): Promise<Event> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/${eventId}`)
      .then((response: AxiosResponse) => resolve(response.data as Event))
      .catch((e) => reject(e));
  });
}

export function getQuarantineImageCountOfEvent(eventId: string): Promise<number> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/quarantine/${eventId}/quarantine-count`)
      .then((response: AxiosResponse) => resolve(response.data as number))
      .catch((e) => reject(e));
  });
}

export function getFailedImages(eventId: string): Promise<FailedEventDay[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/${eventId}/failedImages`)
      .then((response: AxiosResponse) => resolve(response.data as FailedEventDay[]))
      .catch((e) => reject(e));
  });
}

export function getEventStatus(eventId: string): Promise<Status> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/${eventId}/status`)
      .then((response: AxiosResponse) => resolve(response.data.eventStatus as Status))
      .catch((e) => reject(e));
  });
}

export function getEventCameras(eventId: string): Promise<EventDay[]> {
  return new Promise((resolve, reject) => {
    get(`/api/eaus/v1/events/${eventId}/cameras`)
      .then((response: AxiosResponse) => resolve(response.data as EventDay[]))
      .catch((e) => reject(e));
  });
}

export function deleteCamera(eventId: string, deleteRequest: CameraDeleteRequest): Promise<AxiosResponse> {
  return _delete(`/api/eaus/v1/events/${eventId}/cameras`, deleteRequest);
}

export async function completeEvent(eventCompleteRequest: EventCompleteRequest): Promise<EventCompleteResponse> {
  let response;
  if (eventCompleteRequest.overrideRequest) {
    response = await patch(
      `/api/eaus/v1/events/${eventCompleteRequest.eventId}/override`,
      eventCompleteRequest.overrideRequest
    );
  } else {
    response = await patch(
      `/api/eaus/v1/events/${eventCompleteRequest.eventId}?completionMode=${eventCompleteRequest.completionMode}`
    );
  }
  return response.data as EventCompleteResponse;
}

export async function cancelCompleteEvent(eventId: string): Promise<EventCompleteResponse> {
  let response;
  response = await patch(`/api/eaus/v1/events/cancel-pending-event-completion/${eventId}`);

  if (response.status === 200) {
    return { success: true } as EventCompleteResponse;
  }
  return response.data as EventCompleteResponse;
}
